import { useRouteError } from "react-router-dom";
import { RefreshCw } from "lucide-react";
import { brand } from "@/config/brand";
import { Button } from "@/components/ui/button";

function isChunkError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? "");
  return /dynamically imported module|Loading chunk|Importing a module script failed/i.test(message);
}

/**
 * Any screen that throws lands here instead of a blank page. After a new
 * deploy an old tab can miss a screen's file: a reload fixes that, so it is
 * the first thing offered.
 */
export function RouteError() {
  const error = useRouteError();
  const stale = isChunkError(error);
  if (import.meta.env.DEV) console.error(error);
  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-5 bg-background px-6 text-center">
      <img src={brand.logoPath} alt={brand.name} className="h-8 w-auto" />
      <div className="max-w-sm">
        <h1 className="text-title3 text-ink">{stale ? "There's a newer version" : "Something went wrong"}</h1>
        <p className="mt-2 text-subheadline text-muted-foreground">
          {stale ? "Reload to get the latest version of the app." : "Reload the page. If it keeps happening, message your strategist or call us at "}
          {stale ? null : (
            <>
              <a className="font-semibold text-primary" href={brand.supportPhoneHref}>
                {brand.supportPhone}
              </a>
              .
            </>
          )}
        </p>
      </div>
      <Button onClick={() => window.location.reload()}>
        <RefreshCw />
        Reload
      </Button>
    </main>
  );
}
